export default {
  // Page title
  'page.title': 'مؤقت',

  // Popular timers
  'popular.title': 'المؤقتات الشائعة',
  'popular.10s': 'مؤقت 10 ثواني',
  'popular.20s': 'مؤقت 20 ثانية',
  'popular.30s': 'مؤقت 30 ثانية',
  'popular.40s': 'مؤقت 40 ثانية',
  'popular.50s': 'مؤقت 50 ثانية',
  'popular.90s': 'مؤقت دقيقة ونصف',
  'popular.2minute': 'مؤقت دقيقتين',
  'popular.3minute': 'مؤقت 3 دقائق',
  'popular.5minute': 'مؤقت 5 دقائق',
  'popular.10minute': 'مؤقت 10 دقائق',
  'popular.15minute': 'مؤقت 15 دقيقة',
  'popular.30minute': 'مؤقت 30 دقيقة',
  'popular.60minute': 'مؤقت 60 دقيقة',
  'popular.1hour': 'مؤقت ساعة واحدة',
  'popular.10hour': 'مؤقت 10 ساعات',
  'popular.24hour': 'مؤقت 24 ساعة',
  'popular.48hour': 'مؤقت 48 ساعة',

  // How to use
  'howto.title': 'كيفية ضبط المؤقت',
  'howto.titleMinutes': 'كيفية ضبط مؤقت {{minutes}} دقيقة',
  'howto.titleSeconds': 'كيفية ضبط مؤقت {{seconds}} ثانية',
  'howto.titleHour': 'كيفية ضبط مؤقت {{hours}} ساعة',
  'howto.titleHours': 'كيفية ضبط مؤقت {{hours}} ساعات',
  'howto.step1': '⚙️ اضبط وقتك: انقر على أرقام الساعات أو الدقائق لتعديل الوقت مباشرة. يمكنك ضبط ما يصل إلى 23 ساعة و59 دقيقة لأي مهمة.',
  'howto.step2': '⚡ ضبط سريع للوقت: استخدم أزرار الإضافة السريعة لإضافة 30 ثانية أو دقيقة واحدة أو 5 دقائق أو 10 دقائق أو 30 دقيقة إلى مؤقتك بشكل فوري.',
  'howto.step3': '▶️ ابدأ والتحكم: انقر على "ابدأ" لبدء العد التنازلي. يمكنك الإيقاف المؤقت في أي وقت لأخذ استراحة والمتابعة عندما تكون جاهزاً، أو إعادة الضبط للبدء من جديد.',
  'howto.step4': '🔔 احصل على التنبيهات: استلم إشعارات سطح المكتب وتنبيهات صوتية قابلة للتخصيص عند انتهاء الوقت. يمكنك تشغيل/إيقاف الصوت من الزاوية العلوية اليمنى.',
  'howto.step5': '🖥️ وضع ملء الشاشة: انقر على زر ملء الشاشة للتوقيت بدون تشتيت - مثالي للعروض التقديمية أو التأمل أو جلسات العمل المركزة.',
  'howto.step6': '📱 يعمل في كل مكان: استخدمه على أي جهاز - الكمبيوتر المكتبي أو الجهاز اللوحي أو الهاتف المحمول. لا يتطلب تنزيل، يعمل مباشرة في متصفحك.',

  // User review submission
  'reviewSubmission.title': 'شارك تجربتك',
  'reviewSubmission.subtitle': 'ساعد الآخرين على اكتشاف هذا المؤقت من خلال مشاركة تجربتك',
  'reviewSubmission.ratingLabel': 'قيّم تجربتك',
  'reviewSubmission.commentLabel': 'تقييمك (اختياري)',
  'reviewSubmission.commentPlaceholder': 'أخبرنا كيف ساعدك هذا المؤقت في الإنتاجية أو الطهي أو الدراسة أو أي أنشطة أخرى...',
  'reviewSubmission.nameLabel': 'اسمك (اختياري)',
  'reviewSubmission.namePlaceholder': 'كيف يجب أن نعرض اسمك؟',
  'reviewSubmission.submitButton': 'إرسال التقييم',
  'reviewSubmission.thankYou': 'شكراً لك على تقييمك!',
  'reviewSubmission.thankYouMessage': 'ملاحظاتك تساعدنا على التحسين وتساعد الآخرين على اكتشاف مؤقتنا.',
  'reviewSubmission.error': 'يرجى تحديد تقييم قبل الإرسال.',

  // User reviews
  'reviews.title': 'ما يقوله مستخدمونا',
  'reviews.newReview': 'تقييم جديد',
  'reviews.mikeZhang': 'غيّر قواعد اللعبة لإنتاجيتي! تقنية بومودورو مع هذا المؤقت ساعدتني على إنهاء رسالتي. واجهة نظيفة، بدون تشتيت.',
  'reviews.lisaLee': 'مثالي لتوقيت المطبخ! لن أطهو البيض أكثر من اللازم مرة أخرى. التنبيهات الصوتية عالية بما يكفي لكنها ليست مزعجة. أمي المسنة تحبه أيضاً.',
  'reviews.johnDeveloper': 'أفضل مؤقت لاستراحات البرمجة على الإطلاق! الأزرار المعدة مسبقاً توفر الكثير من الوقت. يساعد في منع إجهاد العين ويبقيني مركزاً خلال فترات العمل.',
  'reviews.msChen': 'حوّل إدارة صفي الدراسي! الطلاب يستمتعون فعلاً بالأنشطة الموقوتة الآن. العد التنازلي المرئي يبقي الجميع منخرطين.',
  'reviews.fitnessPro': 'ثوري لتمارين HIIT! توقيت دقيق، عناصر تحكم سهلة حتى مع اليدين المبللتين بالعرق. عملائي يحبون وضع ملء الشاشة.',
  'reviews.sarahMarketer': 'عزز كفاءة اجتماعاتي بنسبة 40%! لا مزيد من النقاشات اللانهائية. حدود الوقت تجبر على اتخاذ القرارات وتبقي الجميع مركزين.',
  'reviews.tomChef': 'ضروري في مطبخ مطعمي! المعكرونة واللحوم والصلصات - توقيت مثالي في كل مرة. أزرار الإضافة السريعة المتعددة عبقرية.',
  'reviews.amyStudent': 'غيّر قواعد اللعبة للدراسة! يكسر دورة المماطلة بأجزاء زمنية قابلة للإدارة. انتقلت من درجات C إلى A باستخدام هذه الطريقة.',
  'reviews.davidWriter': 'عالج حصار الكاتب لدي! سباقات الكتابة لمدة 15 دقيقة تخلق زخماً. نشرت 3 مقالات هذا الشهر بفضل هذا المؤقت.',
  'reviews.rachelTherapist': 'مثالي لجلسات التأمل مع العملاء. التنبيهات اللطيفة لا تكسر الجو الهادئ. احترافي للغاية.',
  // Preset timer specific reviews
  'reviews.managerZhang': 'ضروري للعمل المكتبي! مثالي لتحضير الشاي واستراحات الاجتماعات، الواجهة النظيفة لن تشتت عن العمل.',
  'reviews.mrsLi': 'مؤقت بيض مثالي! البيض المسلوق لمدة 3 دقائق يخرج مثالياً في كل مرة، التنبيهات الصوتية مدروسة جداً، لا بيض مطهو أكثر من اللازم.',
  'reviews.programmerWang': 'ضروري لتمارين العين خلال فترات راحة البرمجة، 3 دقائق مناسبة تماماً لإرخاء عضلات العين، رائع لحماية البصر!',

  // Use cases
  'useCases.title': 'حالات استخدام مؤقت {{minutes}} دقيقة',
  'useCases.titleSeconds': 'حالات استخدام مؤقت {{seconds}} ثانية',
  'useCases.titleHours': 'حالات استخدام مؤقت {{hours}} ساعات',

  // Page titles
  'pageTitle': 'مؤقت {{minutes}} دقيقة',
  'pageTitleSeconds': 'مؤقت {{seconds}} ثانية',
  'pageTitleHour': 'مؤقت {{hours}} ساعة',
  'pageTitleHours': 'مؤقت {{hours}} ساعات',

  // User names
  'user.mikeZhang': 'مايك تشانغ',
  'user.lisaLee': 'ليزا لي',
  'user.johnDeveloper': 'جون المطور',
  'user.msChen': 'السيدة تشن',
  'user.fitnessPro': 'محترف اللياقة',
  'user.sarahMarketer': 'سارة التسويق',
  'user.tomChef': 'الشيف توم',
  'user.amyStudent': 'إيمي الطالبة',
  'user.davidWriter': 'ديفيد الكاتب',
  'user.rachelTherapist': 'راشيل المعالجة',
  // Preset timer specific users
  'user.managerZhang': 'المدير تشانغ',
  'user.mrsLi': 'السيدة لي',
  'user.programmerWang': 'المبرمج وانغ',

  // Use cases
  'useCases.quickBreak.title': 'استراحة سريعة',
  'useCases.quickBreak.desc': 'استراحة قصيرة بين جلسات العمل لتنشيط ذهنك ومنع الإرهاق',
  'useCases.eyeCare.title': 'تذكير العناية بالعين',
  'useCases.eyeCare.desc': 'اتبع قاعدة 20-20-20: كل 20 دقيقة، انظر إلى شيء على بعد 6 أمتار لمدة 20 ثانية',
  'useCases.teaBrewing.title': 'تحضير الشاي',
  'useCases.teaBrewing.desc': 'وقت النقع المثالي للشاي الأخضر (3 دقائق) أو الشاي الأسود (5 دقائق) أو خلطات الأعشاب',
  'useCases.lightExercise.title': 'تمارين خفيفة',
  'useCases.lightExercise.desc': 'تمارين التمدد في المكتب أو يوغا المكتب أو تمارين بسيطة لمكافحة نمط الحياة المستقر',
  'useCases.meditation.title': 'اليقظة والتأمل',
  'useCases.meditation.desc': 'تمارين التنفس الموجهة أو ممارسة اليقظة الذهنية أو التأمل لتخفيف التوتر',
  'useCases.softBoiledEggs.title': 'مؤقت الطهي',
  'useCases.softBoiledEggs.desc': 'توقيت مثالي للبيض المسلوق (5 دقائق) أو طهي المعكرونة أو أي مهمة في المطبخ',
  'useCases.quickReading.title': 'قراءة مركزة',
  'useCases.quickReading.desc': 'جلسات قراءة مركزة للكتب أو المقالات أو مواد الدراسة',
  'useCases.phoneCall.title': 'مؤقت المكالمات والاجتماعات',
  'useCases.phoneCall.desc': 'حافظ على المكالمات الهاتفية على المسار الصحيح، حدد مدة الاجتماعات، أو وقّت العروض التقديمية',
  'useCases.focusedWork.title': 'جلسات عمل بومودورو',
  'useCases.focusedWork.desc': 'تقنية بومودورو الكلاسيكية - 25 دقيقة من العمل المركز تليها استراحة',
  'useCases.exercise.title': 'التمرين والتدريب',
  'useCases.exercise.desc': 'فترات عالية الكثافة أو التدريب الدائري أو مدة تمرين محددة',
  // 15-minute specific
  'useCases.shortMeeting.title': 'اجتماعات سريعة',
  'useCases.shortMeeting.desc': 'تحديثات سريعة للفريق أو اجتماعات يومية قصيرة أو مناقشات تعاونية موجزة',
  'useCases.powerNap.title': 'قيلولة منعشة',
  'useCases.powerNap.desc': 'مدة القيلولة المثالية لتعزيز الطاقة دون الشعور بالنعاس',
  'useCases.learning.title': 'جلسات التعلم',
  'useCases.learning.desc': 'ممارسة اللغة أو دروس المهارات أو مقاطع الفيديو التعليمية',
  'useCases.creativity.title': 'سباقات إبداعية',
  'useCases.creativity.desc': 'جلسات العصف الذهني أو سباقات الكتابة أو الممارسة الفنية',
  // 30-minute specific
  'useCases.deepWork.title': 'جلسة عمل عميق',
  'useCases.deepWork.desc': 'عمل مركز ممتد مع انقطاعات قليلة للمهام المعقدة',
  'useCases.workout.title': 'تمرين كامل',
  'useCases.workout.desc': 'روتين تمرين كامل أو جلسة يوغا أو برنامج تدريبي منظم',
  'useCases.study.title': 'كتلة دراسية',
  'useCases.study.desc': 'جلسات دراسة مكثفة للامتحانات أو البحث أو تطوير المهارات',
  'useCases.presentation.title': 'ممارسة العرض التقديمي',
  'useCases.presentation.desc': 'تدرّب على الخطب أو تمرن على العروض أو وقّت تقديم العرض',

  // Timer-specific user reviews
  // 1-minute timer users
  'user.officeWorkerAlex': 'أليكس الموظف',
  'user.developerSarah': 'سارة المطورة',
  'user.designerMike': 'مايك المصمم',
  'reviews.officeWorkerAlex': 'مثالي لاستراحات سريعة بين الاجتماعات! دقيقة واحدة فقط للتمدد وإعادة التركيز تحدث فرقاً كبيراً.',
  'reviews.developerSarah': 'رائع لقاعدة 20-20-20 - كل 20 دقيقة أنظر إلى شيء على بعد 6 أمتار لمدة دقيقة. عيناي تشعران بتحسن كبير!',
  'reviews.designerMike': 'أستخدم هذا لاستراحات صغيرة خلال العمل التصميمي المكثف. قصيرة لكن فعالة لمنع الإرهاق.',

  // 3-minute timer users
  'user.teaLoverEmily': 'إيميلي محبة الشاي',
  'user.yogatrainerJohn': 'جون مدرب اليوغا',
  'user.busyMomLisa': 'ليزا الأم المشغولة',
  'reviews.teaLoverEmily': 'توقيت مثالي لشاي الأخضر الخاص بي! 3 دقائق تعطي النكهة المثالية دون مرارة. أحب التنبيه الصوتي!',
  'reviews.yogatrainerJohn': 'أستخدم هذا لتمارين التنفس السريعة مع العملاء. 3 دقائق مناسبة تماماً لجلسة مهدئة.',
  'reviews.busyMomLisa': 'رائع لتوقيت تفريش أسنان أطفالي. إنهم يستمتعون بالعد التنازلي الآن!',

  // 5-minute timer users
  'user.meditatorZen': 'المعلم زِن',
  'user.chefTony': 'الشيف توني',
  'user.runnerMia': 'ميا العداءة',
  'reviews.meditatorZen': 'مثالي لتأمل المبتدئين. 5 دقائق قابلة للإدارة لكنها فعالة لممارسة اليقظة الذهنية.',
  'reviews.chefTony': 'ضروري في مطبخي! توقيت مثالي للبيض المسلوق في كل مرة. احترافي وموثوق.',
  'reviews.runnerMia': 'أستخدم هذا لتمارين التمدد بعد الجري. 5 دقائق تضمن أنني لا أتخطى روتين التعافي!',

  // 10-minute timer users
  'user.studentDavid': 'ديفيد الطالب',
  'user.managerRachel': 'راشيل المديرة',
  'user.writerJames': 'جيمس الكاتب',
  'reviews.studentDavid': 'رائع لاستراحات الدراسة! 10 دقائق مثالية لإعادة ضبط عقلي دون فقدان الزخم.',
  'reviews.managerRachel': 'أستخدم هذا لجلسات قراءة مركزة. 10 دقائق من القراءة المتواصلة تتراكم حقاً!',
  'reviews.writerJames': 'مثالي لسباقات الكتابة الموقوتة. ضغط 10 دقائق يساعدني على التغلب على حصار الكاتب.',

  // 15-minute timer users
  'user.consultantAmy': 'إيمي الاستشارية',
  'user.teacherBen': 'بن المعلم',
  'user.freelancerSophie': 'صوفي المستقلة',
  'reviews.consultantAmy': 'مثالي للمكالمات السريعة مع العملاء والاجتماعات القصيرة. يحافظ على النقاشات مركزة ومنتجة.',
  'reviews.teacherBen': 'أستخدم هذا للأنشطة الصفية والعمل الجماعي. الطلاب يبقون منخرطين مع حد الوقت.',
  'reviews.freelancerSophie': 'جلسات بومودورو مثالية! 15 دقيقة من العمل المركز تليها استراحة تبقيني منتجة طوال اليوم.',

  // 30-minute timer users
  'user.executiveRobert': 'روبرت التنفيذي',
  'user.fitnessCoachMaya': 'مايا مدربة اللياقة',
  'user.artistOlivia': 'أوليفيا الفنانة',
  'reviews.executiveRobert': 'ممتاز لجلسات العمل العميق. 30 دقيقة تسمح بتقدم ملموس دون التزام مرهق.',
  'reviews.fitnessCoachMaya': 'مثالي لدوائر التمرين الكاملة. عملائي يحبون التوقيت المنظم لتمارين مختلفة.',
  'reviews.artistOlivia': 'رائع للجلسات الإبداعية. 30 دقيقة تعطي وقتاً كافياً للدخول في حالة التدفق وإنشاء شيء ذو معنى.',
};